import Backdrop from '@mui/material/Backdrop';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setHasEntered, setSidebar } from '../../store/sidebarDrawer';
import ActiveCall from '../Dialer/ActiveCall/ActiveCall';
import { IncomingCall } from '../Dialer/IncomingCall/IncomingCall';
import ToastNotifications from '../ToastNotifications/ToastNotifications';
import PageNavigation from './PageNavigation/PageNavigation';
import SidebarDrawer from './SidebarDrawer/SidebarDrawer';

export type DrawerComponents = 'new/Recent' | 'groups' | 'settings' | 'campaigns' | 'help';

interface Props {
    children: React.ReactElement;
}

export default function PageLayout({ children }: Props) {
    const theme = useTheme();
    const drawerState = useAppSelector(state => state.sidebarDrawer);
    const dispatch = useAppDispatch();
    const hasLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

    return (
        <React.Fragment>
            <div className="pageLayout">
                <div className="pageLayout__nav">
                    <PageNavigation
                        drawerComponent={drawerState.active}
                        hasLargeScreen={hasLargeScreen}
                    />
                </div>
                <div className="pageLayout__transitionWrapper">
                    {!hasLargeScreen && (
                        <Backdrop
                            open={!!drawerState.active}
                            onClick={() => dispatch(setSidebar({ active: null }))}
                        />
                    )}
                    <CSSTransition
                        in={!!drawerState.active}
                        timeout={240}
                        mountOnEnter
                        onEntered={() => hasLargeScreen && dispatch(setHasEntered(true))}
                        onExiting={() => hasLargeScreen && dispatch(setHasEntered(false))}
                    >
                        <>
                            <div className="pageLayout__drawer pageLayout__transition--slide">
                                <Paper elevation={0} square>
                                    <SidebarDrawer
                                        hasEntered={drawerState.hasEntered}
                                        drawerComponent={drawerState.active}
                                        groupsList={drawerState.groupsList}
                                    />
                                </Paper>
                            </div>
                        </>
                    </CSSTransition>
                    <div
                        className={
                            !!drawerState.active
                                ? 'pageLayout__content--shrink'
                                : 'pageLayout__content'
                        }
                    >
                        <ActiveCall />
                        <IncomingCall />
                        <>{children}</>
                    </div>
                </div>
            </div>
            <ToastNotifications />
        </React.Fragment>
    );
}
